import { createAction } from 'redux-actions';

export const getBaseUrl	= createAction("GET_BASE_URL");
export const signInLoading = createAction("SIGN_IN_LOADING");
